module.exports = __webpack_public_path__ + "static/media/VDWXR2.66e334e4.png";